<template>
  <div>
    <v-tabs
      v-model="tab"
      color="grey lighten-3"
      active-class="grey"
      background-color="grey lighten-3"
      hide-slider
    >
      <v-tab>Contrato</v-tab>
      <v-tab>Veículo</v-tab>
      <v-tab>Documento</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <ContratoForm />
      </v-tab-item>
      <v-tab-item>
        <VeiculoContratoTable />
      </v-tab-item>
      <v-tab-item>
        <TabDocumento />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import VeiculoContratoTable from '../veiculo/Table.vue';
import ContratoForm from '../Form.vue';
import TabDocumento from './TabDocumento.vue';

export default {
  name: 'ContratoTabs',
  components: { TabDocumento, VeiculoContratoTable, ContratoForm },
  data: () => ({
    tab: null,
  }),
  computed: {},
  methods: {},
  watch: {},
};
</script>
